import React from "react";
import Link from "next/link";
import styles from "./blog_trending_box.module.scss";
import { getAssets } from "@unisearch/helpers";
import Image from "next/legacy/image";

const CategoryBox = ({ post }) => {
  return (
    <div className={`${styles.trending_box}`}>
      <Link legacyBehavior href={`/blog/category/${post?.slug}`}>
        <a>
          <div className={styles.image_wrapper}>
            <Image
              layout="fill"
              blurDataURL={getAssets(
                "assets/images/study/country_placeholder.webp"
              )}
              placeholder="blur"
              src={
                post?.featureImageSrc ||
                getAssets("/assets/images/image_placeholder_big.webp")
              }
              alt={post?.categoryName}
            />
          </div>
          <div className={`${styles.cat_title}`}>{post?.categoryName}</div>
        </a>
      </Link>
    </div>
  );
};

export default CategoryBox;
